import { useLang } from "@/i18n/LanguageContext";
import { galleryImages } from "@/data/media";

const spanClass = {
  tall: "row-span-2",
  wide: "md:col-span-2",
  square: "",
  panorama: "md:col-span-2",
};

const Gallery = () => {
  const { t, lang } = useLang();

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 border-t border-[#1f1f1f]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#dc2626]" />
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#dc2626]">
                {t("gallery.tag")}
              </p>
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl lg:text-6xl leading-[0.95] mb-6">
              {t("gallery.heading")}
            </h2>
            <p className="text-base md:text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              {t("gallery.lead")}
            </p>
          </div>
          <div className="lg:col-span-5 flex lg:justify-end lg:items-end">
            <p className="font-mono text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#52525b]">
              {galleryImages.length} · Selected works
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 auto-rows-[200px] md:auto-rows-[230px]">
          {galleryImages.map((g, i) => (
            <a
              key={i}
              href={g.src}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden group ${spanClass[g.span] || ""}`}
            >
              <img
                src={g.src}
                alt={g.title[lang]}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent opacity-90 group-hover:opacity-100" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <p className="font-display font-bold text-sm md:text-base text-white uppercase tracking-tight">
                  {g.title[lang]}
                </p>
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#a1a1aa] mt-1">
                  {g.meta[lang]}
                </p>
              </div>
              <span className="absolute top-3 right-3 w-8 h-8 bg-[#dc2626] text-white font-mono text-[10px] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                {String(i + 1).padStart(2, "0")}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
